import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSurgicalHistory,
  addSurgicalHistory,
  updateSurgicalHistory,
  removeSurgicalHistory,
} from "../thunks/surgicalHistoryThunks";

const initialState = { data: [], loading: false, error: null, hasFetched: false };

const surgicalSlice = createSlice({
  name: "surgicalHistory",
  initialState,
  reducers: {
    resetSurgicalHistory: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
      // ---- FETCH ----
      .addCase(fetchSurgicalHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSurgicalHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.hasFetched = true;
      })
      .addCase(fetchSurgicalHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.hasFetched = true;
      })

      // ---- ADD ----
      .addCase(addSurgicalHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addSurgicalHistory.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) state.data.push(action.payload);
      })
      .addCase(addSurgicalHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ---- UPDATE ----
      .addCase(updateSurgicalHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSurgicalHistory.fulfilled, (state, action) => {
        state.loading = false;
        const i = state.data.findIndex((x) => x.id === action.payload?.id);
        if (i !== -1) state.data[i] = action.payload;
      })
      .addCase(updateSurgicalHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ---- DELETE ----
      .addCase(removeSurgicalHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeSurgicalHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter((item) => item.id !== action.payload);
      })
      .addCase(removeSurgicalHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetSurgicalHistory } = surgicalSlice.actions;
export default surgicalSlice.reducer;
